/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class CustomGeojsonApi extends runtime.BaseAPI {
    /**
     * Create Flat Geo Buffer
     */
    async transformToFgbRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling transformToFgb().');
        }
        const queryParameters = {};
        if (requestParameters['fileId'] != null) {
            queryParameters['file_id'] = requestParameters['fileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/custom_geojson/transform_to_fgb`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Flat Geo Buffer
     */
    async transformToFgb(requestParameters, initOverrides) {
        const response = await this.transformToFgbRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Custom Geojson
     */
    async v2DeleteCustomGeojsonRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling v2DeleteCustomGeojson().');
        }
        const queryParameters = {};
        if (requestParameters['fileId'] != null) {
            queryParameters['file_id'] = requestParameters['fileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/custom_geojson/delete`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete Custom Geojson
     */
    async v2DeleteCustomGeojson(requestParameters, initOverrides) {
        const response = await this.v2DeleteCustomGeojsonRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Custom Geojson
     */
    async v2GetCustomGeojsonRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling v2GetCustomGeojson().');
        }
        const queryParameters = {};
        if (requestParameters['fileId'] != null) {
            queryParameters['file_id'] = requestParameters['fileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/custom_geojson/`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get Custom Geojson
     */
    async v2GetCustomGeojson(requestParameters, initOverrides) {
        const response = await this.v2GetCustomGeojsonRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get List Custom Geojson
     */
    async v2GetListCustomGeojsonRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/custom_geojson/list`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get List Custom Geojson
     */
    async v2GetListCustomGeojson(initOverrides) {
        const response = await this.v2GetListCustomGeojsonRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get Total Size
     */
    async v2GetTotalSizeGeojsonsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/custom_geojson/total_size`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get Total Size
     */
    async v2GetTotalSizeGeojsons(initOverrides) {
        const response = await this.v2GetTotalSizeGeojsonsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Backfill Custom Geojson Size
     */
    async v2UpdateFileSizeRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/custom_geojson/update_file_size`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Backfill Custom Geojson Size
     */
    async v2UpdateFileSize(initOverrides) {
        const response = await this.v2UpdateFileSizeRaw(initOverrides);
        return await response.value();
    }
    /**
     * Upload Custom Geojson
     */
    async v2UploadCustomGeojsonRaw(requestParameters, initOverrides) {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError('name', 'Required parameter "name" was null or undefined when calling v2UploadCustomGeojson().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling v2UploadCustomGeojson().');
        }
        const queryParameters = {};
        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/custom_geojson/upload`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Upload Custom Geojson
     */
    async v2UploadCustomGeojson(requestParameters, initOverrides) {
        const response = await this.v2UploadCustomGeojsonRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload Custom Geojson By Username
     */
    async v2UploadCustomGeojsonByUsernameRaw(requestParameters, initOverrides) {
        if (requestParameters['customerUserName'] == null) {
            throw new runtime.RequiredError('customerUserName', 'Required parameter "customerUserName" was null or undefined when calling v2UploadCustomGeojsonByUsername().');
        }
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError('name', 'Required parameter "name" was null or undefined when calling v2UploadCustomGeojsonByUsername().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling v2UploadCustomGeojsonByUsername().');
        }
        const queryParameters = {};
        if (requestParameters['customerUserName'] != null) {
            queryParameters['customer_user_name'] = requestParameters['customerUserName'];
        }
        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/custom_geojson/upload2`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Upload Custom Geojson By Username
     */
    async v2UploadCustomGeojsonByUsername(requestParameters, initOverrides) {
        const response = await this.v2UploadCustomGeojsonByUsernameRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
